const COURSE_LABELS = {
  C: "C", JAVA: "Java", PYTHON: "Python",
  DSA: "DSA", DATA_SCIENCE: "Data Science",
};

const prettyCourse = (raw) =>
  COURSE_LABELS[raw.toUpperCase()] ??
  raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const mk = (y, mo, d, h = 0, mi = 0, s = 0) =>
  new Date(+y, +mo - 1, +d, +h, +mi, +s);

const PARSERS = [
  {
    // ADAPTIVE_<title>_2026_09_03_16_40_03_97ca578a
    re: /^ADAPTIVE_(.+)_(\d{4})_(\d{2})_(\d{2})_(\d{2})_(\d{2})_(\d{2})_([0-9a-f]+)$/i,
    build: ([, title, y, mo, d, h, mi, s, id]) => ({
      type: "Adaptive",
      title: title.replace(/_/g, " "),
      date: mk(y, mo, d, h, mi, s),
      id,
    }),
  },
  {
    // CUSTOM_DATA_SCIENCE_20260518_1114_9658
    re: /^CUSTOM_(.+)_(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})_(\w+)$/i,
    build: ([, course, y, mo, d, h, mi, id]) => ({
      type: "Custom",
      title: `${prettyCourse(course)} (Custom)`,
      date: mk(y, mo, d, h, mi),
      id,
    }),
  },
  {
    // DSA_20261021_143123_422e9897
    re: /^(.+)_(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})_([0-9a-f]+)$/i,
    build: ([, course, y, mo, d, h, mi, s, id]) => ({
      type: "Course",
      title: `${prettyCourse(course)} Test`,
      date: mk(y, mo, d, h, mi, s),
      id,
    }),
  },
];

export function parseTestName(raw) {
  const name = String(raw ?? "");
  for (const { re, build } of PARSERS) {
    const m = name.match(re);
    if (m) return { raw: name, valid: true, ...build(m) };
  }
  return { raw: name, valid: false, title: name };
}

export function formatTest(raw) {
  const t = parseTestName(raw);
  if (!t.valid) return { title: t.raw, subtitle: "", badge: "" };

  const when = t.date.toLocaleString(undefined, {
    day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });

  return {
    title: t.title,
    subtitle: `${when} · #${t.id.slice(0, 6)}`,
    badge: t.type,
  };
}

export const sortNewestFirst = (names) =>
  [...names].sort((a, b) => {
    const da = parseTestName(a).date?.getTime() ?? 0;
    const db = parseTestName(b).date?.getTime() ?? 0;
    return db - da;
  });